import Axios from 'axios'
import {
  Message
} from 'iview'
import qs from 'qs'
import store from '@/store'

const conf = {
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  },
  timeout: 30000,
  baseURL: process.env.NODE_ENV === 'production'
    ? '/' // 'http://www.airqh.com:80/' // production base url
    :
    'http://127.0.0.1:80//' // development base url
}
const instance = Axios.create(conf)
instance.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['x-token'] = store.getters.token
  }
  return config
})
instance.interceptors.response.use(res => {
  return res
}, error => {
  // Handling Errors
  if (error.toString() === 'Cancel') {
    error.message = 'cancel by user'
    console.log(error.message)
    return Promise.reject(error)
  } else {
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 403) {
        Message.error(error.response.data.message)
        return Promise.reject(error.response)
      }
    } else if (error.request) {
      Message.error('ajax_error')
      return Promise.reject(error.request)
    } else {
      // Something happened in setting up the request that triggered an Error
      Message.error('ajax_error')
      return Promise.reject(error.message)
    }
  }
})

export default {
  request (options) {
    return instance(options)
  },
  // 以form表单方式提交数据
  formRequest (options) {
    if (!options.data) {
      return instance({
        url: options.url,
        method: 'get'
      })
    }
    return instance({
      url: options.url,
      method: 'post',
      data: qs.stringify(options.data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/libs/httpRequest.js